import {SpreadSummary} from "../../../../../types/OrderSpread";
import {StringKeyed} from "../../../../../types/GenericTypes";
import {Optional} from "../../../../../js/util/Optional";
import {ArrayUtil} from "../../../../../js/util/ArrayUtil";

export class OrderSpreads {

    protected constructor(protected readonly spreadsMap: StringKeyed<SpreadSummary>) {
    }

    public spreads(): ReadonlyArray<SpreadSummary> {
        return Object.values(this.spreadsMap);
    }

    public spreadFor(code: string): Optional<SpreadSummary> {
        const spread = this.spreadsMap[code];
        return Optional.of(spread);
    }

    public static of(spreads: ReadonlyArray<SpreadSummary>): OrderSpreads {
        const map = ArrayUtil.toMap(spreads, sp => sp.code);
        return new OrderSpreads(map);
    }
}

export class TmcSpreads extends OrderSpreads {

    private constructor(public readonly tmcSpread: SpreadSummary,
                        legSpreads: StringKeyed<SpreadSummary>) {
        super(legSpreads);
    }

    public legSpreadFor(code: string): Optional<SpreadSummary> {
        return this.spreadFor(code);
    }

    public static from(tmcCode: string, spreads: ReadonlyArray<SpreadSummary>): TmcSpreads {
        const tmcSpread = spreads.find(sp => sp.code === tmcCode);
        const legSpreads = spreads.filter(sp => sp.code !== tmcCode);
        const legSpreadMap = ArrayUtil.toMap(legSpreads, sp => sp.code);
        return new TmcSpreads(tmcSpread!, legSpreadMap);
    }
}
